var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { isEmpty, isPresent } from '@ember/utils';
import { get, computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { FeCountryAddressDataRequest } from '@square/dashboard-protos/models/squareup/address/service';
import { CountryAddressData } from '@square/dashboard-protos/models/squareup/address/country_data';
import address from '@dashboard/shared-ui/clients/address';
import { validates } from 'lgtm';
import AddressInputFieldStreet1Old from '@dashboard/shared-ui/components/addresses/address-input-field-street1-old';
import AddressInputFieldStreet2Old from '@dashboard/shared-ui/components/addresses/address-input-field-street2-old';
import AddressInputFieldLocalityOld from '@dashboard/shared-ui/components/addresses/address-input-field-locality-old';
import AddressInputFieldSublocalityOld from '@dashboard/shared-ui/components/addresses/address-input-field-sublocality-old';
import AddressInputFieldAdmin1Old from '@dashboard/shared-ui/components/addresses/address-input-field-admin1-old';
import AddressInputFieldPostalOld from '@dashboard/shared-ui/components/addresses/address-input-field-postal-old';
import AddressInputFieldStreet1 from '@dashboard/shared-ui/components/addresses/address-input-field-street1';
import AddressInputFieldStreet2 from '@dashboard/shared-ui/components/addresses/address-input-field-street2';
import AddressInputFieldLocality from '@dashboard/shared-ui/components/addresses/address-input-field-locality';
import AddressInputFieldSublocality from '@dashboard/shared-ui/components/addresses/address-input-field-sublocality';
import AddressInputFieldAdmin1 from '@dashboard/shared-ui/components/addresses/address-input-field-admin1';
import AddressInputFieldPostal from '@dashboard/shared-ui/components/addresses/address-input-field-postal';

// Replacement characters found in countryAddressData fields. Other possible replacements:
//   New line: %n
//   Name: %N
//   Organization: %O
const COUNTRY_DATA_REPLACEMENT_DETAILS_OLD = {
  // Street Address Line(s)
  A: {
    components: countryAddressData => {
      if (countryAddressData.defaultLinecount > 1) {
        return [AddressInputFieldStreet1Old, AddressInputFieldStreet2Old];
      }
      return [AddressInputFieldStreet1Old];
    },
    fields: ['addressLine1', 'addressLine2'],
    requiresFullLine: () => true,
    validationMessage: i18n => {
      return i18n.t('addressService.validation.addressLine1');
    }
  },
  // City or Locality
  C: {
    components: () => [AddressInputFieldLocalityOld],
    fields: ['locality'],
    requiresFullLine: () => true,
    validationMessage: (i18n, countryAddressData) => {
      switch (countryAddressData.localityLabel) {
        case CountryAddressData.LocalityScope.LocalityLabel.CITY:
          return i18n.t('addressService.validation.locality.city');
        case CountryAddressData.LocalityScope.LocalityLabel.DISTRICT:
          return i18n.t('addressService.validation.locality.district');
        case CountryAddressData.LocalityScope.LocalityLabel.POST_TOWN:
          return i18n.t('addressService.validation.locality.postTown');
        case CountryAddressData.LocalityScope.LocalityLabel.SUBURB:
          return i18n.t('addressService.validation.locality.suburb');
        case CountryAddressData.LocalityScope.LocalityLabel.TOWN_CITY:
          return i18n.t('addressService.validation.locality.townCity');
        default:
          return i18n.t('addressService.validation.locality.default');
      }
    }
  },
  // Dependent locality (may be an inner-city district or a suburb)
  D: {
    components: () => [AddressInputFieldSublocalityOld],
    fields: ['sublocality'],
    requiresFullLine: () => true,
    validationMessage: (i18n, countryAddressData) => {
      switch (countryAddressData.sublocalityLabel) {
        case CountryAddressData.SublocalityScope.SublocalityLabel.SUBURB:
          return i18n.t('addressService.validation.sublocality.suburb');
        case CountryAddressData.SublocalityScope.SublocalityLabel.DISTRICT:
          return i18n.t('addressService.validation.sublocality.district');
        case CountryAddressData.SublocalityScope.SublocalityLabel.NEIGHBORHOOD:
          return i18n.t('addressService.validation.sublocality.neighborhood');
        case CountryAddressData.SublocalityScope.SublocalityLabel.TOWN:
          return i18n.t('addressService.validation.sublocality.town');
        case CountryAddressData.SublocalityScope.SublocalityLabel.TOWNLAND:
          return i18n.t('addressService.validation.sublocality.townland');
        case CountryAddressData.SublocalityScope.SublocalityLabel.VILLAGE_TOWNSHIP:
          return i18n.t('addressService.validation.sublocality.villageTownship');
        default:
          return i18n.t('addressService.validation.sublocality.default');
      }
    }
  },
  // Administrative area such as a state, province, island etc. see field "state_name_type" or "province_name_type"
  S: {
    components: () => [AddressInputFieldAdmin1Old],
    fields: ['adminLevel1'],
    requiresFullLine: countryAddressData => {
      return Math.max(...countryAddressData.admin1Values.mapBy('name.length')) > 25;
    },
    validationMessage: (i18n, countryAddressData) => {
      switch (countryAddressData.admin1Label) {
        case CountryAddressData.Admin1Scope.Admin1Label.AREA:
          return i18n.t('addressService.validation.admin1.area');
        case CountryAddressData.Admin1Scope.Admin1Label.DEPARTMENT:
          return i18n.t('addressService.validation.admin1.department');
        case CountryAddressData.Admin1Scope.Admin1Label.DISTRICT:
          return i18n.t('addressService.validation.admin1.district');
        case CountryAddressData.Admin1Scope.Admin1Label.DO_SI:
          return i18n.t('addressService.validation.admin1.doSi');
        case CountryAddressData.Admin1Scope.Admin1Label.EMIRATE:
          return i18n.t('addressService.validation.admin1.emirate');
        case CountryAddressData.Admin1Scope.Admin1Label.ISLAND:
          return i18n.t('addressService.validation.admin1.island');
        case CountryAddressData.Admin1Scope.Admin1Label.OBLAST:
          return i18n.t('addressService.validation.admin1.oblast');
        case CountryAddressData.Admin1Scope.Admin1Label.PARISH:
          return i18n.t('addressService.validation.admin1.parish');
        case CountryAddressData.Admin1Scope.Admin1Label.PREFECTURE:
          return i18n.t('addressService.validation.admin1.prefecture');
        case CountryAddressData.Admin1Scope.Admin1Label.PROVINCE:
          return i18n.t('addressService.validation.admin1.province');
        case CountryAddressData.Admin1Scope.Admin1Label.STATE:
          return i18n.t('addressService.validation.admin1.state');
        case CountryAddressData.Admin1Scope.Admin1Label.COUNTY:
          return i18n.t('addressService.validation.admin1.county');
        default:
          return i18n.t('addressService.validation.admin1.default');
      }
    }
  },
  // Sorting Code
  // NB(njacobson): Config removed until the field is used by the backend.
  // To add back, reference PR: https://git.sqcorp.co/projects/SQ/repos/dashboard/pull-requests/17544

  // Zip or Postal Code
  Z: {
    components: () => [AddressInputFieldPostalOld],
    fields: ['postalCode'],
    requiresFullLine: countryAddressData => {
      return Math.max(...countryAddressData.examplePostalCodes.mapBy('name.length')) > 25;
    },
    validationMessage: (i18n, countryAddressData) => {
      switch (countryAddressData.postalCodeLabel) {
        case CountryAddressData.PostalCodeScope.PostalCodeLabel.POSTAL:
          return i18n.t('addressService.validation.postalCode.postal');
        case CountryAddressData.PostalCodeScope.PostalCodeLabel.EIRCODE:
          return i18n.t('addressService.validation.postalCode.eirCode');
        case CountryAddressData.PostalCodeScope.PostalCodeLabel.PIN:
          return i18n.t('addressService.validation.postalCode.pin');
        case CountryAddressData.PostalCodeScope.PostalCodeLabel.ZIP:
          return i18n.t('addressService.validation.postalCode.zip');
        default:
          return i18n.t('addressService.validation.postalCode.default');
      }
    }
  }
};
const COUNTRY_DATA_REPLACEMENT_DETAILS = {
  // Street Address Line(s)
  A: {
    components: countryAddressData => {
      if (countryAddressData.defaultLinecount > 1) {
        return [AddressInputFieldStreet1, AddressInputFieldStreet2];
      }
      return [AddressInputFieldStreet1];
    },
    fields: ['addressLine1', 'addressLine2'],
    requiresFullLine: () => true,
    validationMessage: i18n => {
      return i18n.t('addressService.validation.addressLine1');
    }
  },
  // City or Locality
  C: {
    components: () => [AddressInputFieldLocality],
    fields: ['locality'],
    requiresFullLine: () => true,
    validationMessage: (i18n, countryAddressData) => {
      switch (countryAddressData.localityLabel) {
        case CountryAddressData.LocalityScope.LocalityLabel.CITY:
          return i18n.t('addressService.validation.locality.city');
        case CountryAddressData.LocalityScope.LocalityLabel.DISTRICT:
          return i18n.t('addressService.validation.locality.district');
        case CountryAddressData.LocalityScope.LocalityLabel.POST_TOWN:
          return i18n.t('addressService.validation.locality.postTown');
        case CountryAddressData.LocalityScope.LocalityLabel.SUBURB:
          return i18n.t('addressService.validation.locality.suburb');
        case CountryAddressData.LocalityScope.LocalityLabel.TOWN_CITY:
          return i18n.t('addressService.validation.locality.townCity');
        default:
          return i18n.t('addressService.validation.locality.default');
      }
    }
  },
  // Dependent locality (may be an inner-city district or a suburb)
  D: {
    components: () => [AddressInputFieldSublocality],
    fields: ['sublocality'],
    requiresFullLine: () => true,
    validationMessage: (i18n, countryAddressData) => {
      switch (countryAddressData.sublocalityLabel) {
        case CountryAddressData.SublocalityScope.SublocalityLabel.SUBURB:
          return i18n.t('addressService.validation.sublocality.suburb');
        case CountryAddressData.SublocalityScope.SublocalityLabel.DISTRICT:
          return i18n.t('addressService.validation.sublocality.district');
        case CountryAddressData.SublocalityScope.SublocalityLabel.NEIGHBORHOOD:
          return i18n.t('addressService.validation.sublocality.neighborhood');
        case CountryAddressData.SublocalityScope.SublocalityLabel.TOWN:
          return i18n.t('addressService.validation.sublocality.town');
        case CountryAddressData.SublocalityScope.SublocalityLabel.TOWNLAND:
          return i18n.t('addressService.validation.sublocality.townland');
        case CountryAddressData.SublocalityScope.SublocalityLabel.VILLAGE_TOWNSHIP:
          return i18n.t('addressService.validation.sublocality.villageTownship');
        default:
          return i18n.t('addressService.validation.sublocality.default');
      }
    }
  },
  // Administrative area such as a state, province, island etc. see field "state_name_type" or "province_name_type"
  S: {
    components: () => [AddressInputFieldAdmin1],
    fields: ['adminLevel1'],
    requiresFullLine: countryAddressData => {
      return Math.max(...countryAddressData.admin1Values.mapBy('name.length')) > 25;
    },
    validationMessage: (i18n, countryAddressData) => {
      switch (countryAddressData.admin1Label) {
        case CountryAddressData.Admin1Scope.Admin1Label.AREA:
          return i18n.t('addressService.validation.admin1.area');
        case CountryAddressData.Admin1Scope.Admin1Label.DEPARTMENT:
          return i18n.t('addressService.validation.admin1.department');
        case CountryAddressData.Admin1Scope.Admin1Label.DISTRICT:
          return i18n.t('addressService.validation.admin1.district');
        case CountryAddressData.Admin1Scope.Admin1Label.DO_SI:
          return i18n.t('addressService.validation.admin1.doSi');
        case CountryAddressData.Admin1Scope.Admin1Label.EMIRATE:
          return i18n.t('addressService.validation.admin1.emirate');
        case CountryAddressData.Admin1Scope.Admin1Label.ISLAND:
          return i18n.t('addressService.validation.admin1.island');
        case CountryAddressData.Admin1Scope.Admin1Label.OBLAST:
          return i18n.t('addressService.validation.admin1.oblast');
        case CountryAddressData.Admin1Scope.Admin1Label.PARISH:
          return i18n.t('addressService.validation.admin1.parish');
        case CountryAddressData.Admin1Scope.Admin1Label.PREFECTURE:
          return i18n.t('addressService.validation.admin1.prefecture');
        case CountryAddressData.Admin1Scope.Admin1Label.PROVINCE:
          return i18n.t('addressService.validation.admin1.province');
        case CountryAddressData.Admin1Scope.Admin1Label.STATE:
          return i18n.t('addressService.validation.admin1.state');
        case CountryAddressData.Admin1Scope.Admin1Label.COUNTY:
          return i18n.t('addressService.validation.admin1.county');
        default:
          return i18n.t('addressService.validation.admin1.default');
      }
    }
  },
  // Sorting Code
  // NB(njacobson): Config removed until the field is used by the backend.
  // To add back, reference PR: https://git.sqcorp.co/projects/SQ/repos/dashboard/pull-requests/17544

  // Zip or Postal Code
  Z: {
    components: () => [AddressInputFieldPostal],
    fields: ['postalCode'],
    requiresFullLine: countryAddressData => {
      return Math.max(...countryAddressData.examplePostalCodes.mapBy('name.length')) > 25;
    },
    validationMessage: (i18n, countryAddressData) => {
      switch (countryAddressData.postalCodeLabel) {
        case CountryAddressData.PostalCodeScope.PostalCodeLabel.POSTAL:
          return i18n.t('addressService.validation.postalCode.postal');
        case CountryAddressData.PostalCodeScope.PostalCodeLabel.EIRCODE:
          return i18n.t('addressService.validation.postalCode.eirCode');
        case CountryAddressData.PostalCodeScope.PostalCodeLabel.PIN:
          return i18n.t('addressService.validation.postalCode.pin');
        case CountryAddressData.PostalCodeScope.PostalCodeLabel.ZIP:
          return i18n.t('addressService.validation.postalCode.zip');
        default:
          return i18n.t('addressService.validation.postalCode.default');
      }
    }
  }
};

// Regex of replacement characters for parsing country data fields
const COUNTRY_DATA_REPLACEMENT_REGEX = new RegExp(`%(${Object.keys(COUNTRY_DATA_REPLACEMENT_DETAILS).join('|')})`, 'g');
let AddressService = (_class = class AddressService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
  }
  get countryAddressDataCache() {
    return new Map();
  }
  getCountryCodeFromNumericalValue(val) {
    return Object.keys(Country).find(key => Country[key] === val);
  }
  lookupCountryAddressData({
    country,
    locale
  }) {
    // Return null if missing/invalid params
    if (isEmpty(country) || isEmpty(locale)) {
      return Promise.resolve(null);
    }

    // Lookup in cache
    const key = `${country}-${locale}`;
    const cache = this.countryAddressDataCache;
    const data = cache.get(key);
    if (!isEmpty(data)) {
      return data;
    }

    // Make request
    const request = new FeCountryAddressDataRequest.Builder().country(Country[country]).locale(locale).build();
    const response = address.lookupCountryAddressData(request);

    // Store in cache
    cache.set(key, response);

    // Return response
    return response.catch(() => {
      // Remove failed from cache
      cache.delete(key);
      return null;
    });
  }

  // Find coundry address data by just the country code
  lookupCountryAddressDataByCountry(country) {
    // Return null if missing/invalid params
    if (isEmpty(country)) {
      return Promise.resolve(null);
    }

    // Lookup in cache
    const key = `${country}`;
    const cache = this.countryAddressDataCache;
    const data = cache.get(key);
    if (!isEmpty(data)) {
      return data;
    }

    // Make request
    const request = new FeCountryAddressDataRequest.Builder().country(Country[country]).build();
    const response = address.lookupCountryAddressData(request);

    // Store in cache
    cache.set(key, response);

    // Return response
    return response.catch(() => {
      // Remove failed from cache
      cache.delete(key);
      return null;
    });
  }

  // Use the format string to create an array of component names for input display.
  // Each field goes on its own line.
  getCountryAddressFormatBasic(countryAddressData, useMarketUI = false) {
    let countryDataReplacementDetails;
    if (useMarketUI) {
      countryDataReplacementDetails = COUNTRY_DATA_REPLACEMENT_DETAILS;
    } else {
      countryDataReplacementDetails = COUNTRY_DATA_REPLACEMENT_DETAILS_OLD;
    }
    const matches = countryAddressData.format.match(COUNTRY_DATA_REPLACEMENT_REGEX);
    if (isEmpty(matches)) {
      return [];
    }
    const allComponents = matches.filter(matches => !isEmpty(matches)).map(match => match[1]).map(replacement => countryDataReplacementDetails[replacement]).map(details => details.components(countryAddressData));
    return allComponents.flat().map(component => [component]);
  }

  // Use the format string to create an array of component names for input display.
  // In general, each field goes on its own line, but if there are adjacent fields (not
  // seperated by another field or newline) that are small enough to be combined, then
  // use a single, combined component instead.
  getCountryAddressFormatAdvanced(countryAddressData, useMarketUI = false) {
    let countryDataReplacementDetails;
    if (useMarketUI) {
      countryDataReplacementDetails = COUNTRY_DATA_REPLACEMENT_DETAILS;
    } else {
      countryDataReplacementDetails = COUNTRY_DATA_REPLACEMENT_DETAILS_OLD;
    }
    const finalLines = [];
    for (const details of countryAddressData.format
    // Split format string on newlines
    .split('%n')
    // Map each line into an array of replacements
    .map(line => line.match(COUNTRY_DATA_REPLACEMENT_REGEX))
    // Remove matches that are empty
    .filter(matches => !isEmpty(matches))
    // Map matches to captured results
    .map(matches => matches.map(match => match[1]))
    // Map replacement to details objects
    .map(replacements => replacements.map(replacement => Object.assign(countryDataReplacementDetails[replacement], {
      replacement
    })))) {
      let stashedDetail = null;
      // Loop over each line and combine any replacements if possible
      for (const detail of details) {
        if (detail.requiresFullLine(countryAddressData)) {
          // If present, add the stashed details on their own line (previous field was partial line, current is full line)
          if (stashedDetail !== null) {
            finalLines.push(...stashedDetail.components(countryAddressData).map(component => [component]));
            stashedDetail = null;
          }
          // Add the details on their own line
          finalLines.push(...detail.components(countryAddressData).map(component => [component]));
        } else {
          if (stashedDetail !== null) {
            // Details are partial line and can be combined with previous
            finalLines.push([stashedDetail.components(countryAddressData)[0], detail.components(countryAddressData)[0]]);
            stashedDetail = null;
          } else {
            // Details are partial line, stashing to see if next field is also partial line
            stashedDetail = detail;
          }
        }
      }
      if (stashedDetail !== null) {
        finalLines.push(...stashedDetail.components(countryAddressData).map(component => [component]));
      }
    }
    return finalLines;
  }

  // Get a mapping of required address details like [{field: "countryCode", message: "Country is required"}]
  getRequiredAddressDetails(countryAddressData, useMarket = false) {
    let countryDataReplacementDetails;
    if (useMarket) {
      countryDataReplacementDetails = COUNTRY_DATA_REPLACEMENT_DETAILS;
    } else {
      countryDataReplacementDetails = COUNTRY_DATA_REPLACEMENT_DETAILS_OLD;
    }
    // Get ordered array of required details
    let requiredReplacements = [];
    if (!isEmpty(countryAddressData.requiredFields)) {
      if (!isEmpty(countryAddressData.format)) {
        requiredReplacements = (countryAddressData.format.match(COUNTRY_DATA_REPLACEMENT_REGEX) || []).map(match => match[1]).filter(replacement => countryAddressData.requiredFields.includes(replacement));
      }
      if (isEmpty(requiredReplacements)) {
        requiredReplacements = [...countryAddressData.requiredFields];
      }
    }

    // Gather field/translation pairs
    const requiredDetails = requiredReplacements.map(replacement => countryDataReplacementDetails[replacement]).filter(isPresent).map(details => {
      const field = details.fields[0];
      const message = details.validationMessage(this.i18n, countryAddressData);
      return {
        field,
        message
      };
    });
    return requiredDetails;
  }

  // Client-side validations: Get validations to add to builder for LGTM
  getCountryAddressValidations(countryAddressData, useMarketUI = false, useJPScriptAddress = false) {
    // If no country data, nothing to validate
    if (isEmpty(countryAddressData)) {
      return [];
    }
    const requiredDetails = this.getRequiredAddressDetails(countryAddressData, useMarketUI);

    // Return array of country + additional validations
    const countryValidation = validates('address.countryCode').required(this.i18n.t('addressService.validation.country'));

    // Additional validations for Japanese script addresses if useJPScriptAddress is true
    let additionalValidations = [];
    if (useJPScriptAddress) {
      const jpScriptFields = [{
        field: 'scriptAddresses.0.address.postal_code',
        message: this.i18n.t('addressService.validation.postalCode.postal')
      }, {
        field: 'scriptAddresses.0.address.address_line_1',
        message: this.i18n.t('addressService.validation.addressLine1')
      }, {
        field: 'scriptAddresses.0.address.locality',
        message: this.i18n.t('addressService.validation.locality.townCity')
      }, {
        field: 'scriptAddresses.1.address.postal_code',
        message: this.i18n.t('addressService.validation.postalCode.postal')
      }, {
        field: 'scriptAddresses.1.address.address_line_1',
        message: this.i18n.t('addressService.validation.addressLine1')
      }, {
        field: 'scriptAddresses.1.address.locality',
        message: this.i18n.t('addressService.validation.locality.townCity')
      }];
      additionalValidations = jpScriptFields.map(({
        field,
        message
      }) => validates(field).when('scriptAddresses', scriptAddresses => {
        if (!isPresent(scriptAddresses)) {
          return true;
        }
        return scriptAddresses.every(scriptAddress => {
          return Object.keys(scriptAddress.toJSON()).reject(key => key === 'countryCode' || key === '__proto__').some(key => isPresent(get(scriptAddress, key)));
        });
      }).required(message));
    } else {
      additionalValidations = requiredDetails.map(({
        field,
        message
      }) => validates(`address.${field}`).when('address', address => {
        if (!isPresent(address)) {
          return true;
        }
        return Object.keys(address.toJSON()).reject(key => key === 'countryCode' || key === '__proto__').some(key => isPresent(get(address, key)));
      }).required(message));
    }
    return [countryValidation, ...additionalValidations];
  }

  // Get the required address field details by country code like [{field: "countryCode", message: "Country is required"}]
  // This required fetching the country address data via the country code passed in
  async getRequiredAddressValuesByCountry(country, useMarketUI = false) {
    if (!country) {
      return [];
    }
    let countryAddressData = null;
    await this.lookupCountryAddressDataByCountry(country).then(result => {
      countryAddressData = result;
    });
    if (!countryAddressData) {
      return [];
    }
    const requiredDetails = this.getRequiredAddressDetails(countryAddressData, useMarketUI);

    // Return array of country + additional validations
    requiredDetails.push({
      field: 'countryCode',
      message: this.i18n.t('addressService.validation.country')
    });
    return requiredDetails;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "countryAddressDataCache", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "countryAddressDataCache"), _class.prototype), _class);
export { AddressService as default };